(function () {
    'use strict';
    var controllerId = 'commessaDipendenteAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', commessaSelectFn]);

    function commessaSelectFn($scope, $uibModalInstance, datacontext) {
        $scope.item = {};
        $scope.item.fTesto = '';
        $scope.item.commesse = getCommessa();
        $scope.item.selected = selected;
        $scope.item.cerca = getCommessa;
        $scope.item.loading = true;
        $scope.item.ruolo = 'M';
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function selected(id, codice, titolo, ruolo) {
            var resultItem = { 'id': id, 'codice': codice, 'titolo': titolo, 'ruolo': ruolo };
            $uibModalInstance.close(resultItem);
        }

        function getCommessa() {
            $scope.item.loading = true;
            return datacontext.commessa_getAllByFilter(0, 0, $scope.item.fTesto, -1, -1, 'codice').then(function (data) {
                $scope.item.loading = false;
                return $scope.item.commesse = data;
            });
        }        

    }
})();